// tslint:disable

import { get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { WysiwygField } from '../../components/fields/wysiwyg.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import {CheckboxField} from "../../components/fields/checkbox.field";

export class DefaultModalPersonCompany extends React.Component<any, any> {
    public state: any = {
        hasEmitted: {},
        selectedCompany: null
    };

    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateEndPoint('person-company');

        if (this.props.CONFIG.company) {
            form.fields.company.registerField();
            form.fields.company.setValue(`/company/${this.props.CONFIG.company}`);
        }
        if (this.props.CONFIG.person) {
            form.fields.person.registerField();
            form.fields.person.setValue(`/person/${this.props.CONFIG.person}`);
        }

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader
                entity="person-company"
                entityId={this.props.ENTITY_ID}
                render={(form: FormLib) => <div className="row">
                    <LoaderComponent isLoading$={this.executor.loading$}/>

                    <div className="col-xs-12">
                        <div id="page-title">
                            <h2>Set person-company details</h2>
                        </div>
                    </div>

                    <div className="col-xs-12">
                        <ToggleBoxComponent title="Person informations" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    {this.props.CONFIG && this.props.CONFIG.person &&
                                    <IriField
                                        field={form.fields.company}
                                        defaultAll={false}
                                        itemRender={(item: any) => `${item.name}`}
                                        disabled={this.props.CONFIG.disabledPerson}/>
                                    }
                                    {this.props.CONFIG && this.props.CONFIG.company && <div>
                                        <IriField
                                            field={form.fields.person}
                                            defaultAll={false}
                                            itemRender={(item: any) => `${item.firstName} ${item.surName} - ${item.email}`}
                                            disabled={this.props.CONFIG.disabledPerson}/>

                                        {get(form.fields.person, 'value.id') &&
                                        <ResourceModal
                                            entity="person"
                                            entityId={get(form.fields.person, 'value.id')}
                                            title="Update person"
                                        />
                                        }

                                        {!this.props.CONFIG.disabledPerson &&
                                        <ResourceModal
                                            entity="person"
                                            entityId="create"
                                            title="Add new person"
                                        />
                                        }
                                    </div>}

                                    {form.fields.job &&
                                    <IriField
                                        field={form.fields.job}
                                        defaultAll={true}
                                        itemRender={(item: any) => get(item, 'title')}
                                    />
                                    }

                                    <InputField
                                        field={form.fields.phone}
                                        validators={[Validators.isPhoneNumber('Required')]}/>

                                    <CheckboxField
                                        field={form.fields.author}
                                    />

                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Description" defaultClosed={this.props.CONFIG.disabledPerson}>
                            <WysiwygField
                                field={form.fields.description}/>
                        </ToggleBoxComponent>

                    </div>

                    <div className="col-xs-12">
                        <button className="btn btn-primary pull-left"
                                onClick={() => this.saveForm(form)}>Save
                        </button>
                    </div>

                </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.modal.person-company.tsx